import Highlight, { defaultProps } from 'prism-react-renderer';
import theme from 'prism-react-renderer/themes/nightOwl';
import classnames from 'classnames';

import CopyToClipboard from '@/components/CopyToClipboard';
import styles from './Code.module.css';

export default function Code({
  children,
  className: propsClassName = null,
  noCopy = false,
  ...props
}) {
  return (
    <Highlight {...defaultProps} code={children} theme={theme} {...props}>
      {({ className, tokens, getLineProps, getTokenProps }) => (
        <pre
          className={classnames(
            className,
            propsClassName,
            styles.code,
            'rounded bg-big-stone font-mono block p-3 lg:p-6 relative h-full overflow-auto',
          )}
        >
          {!noCopy && (
            <CopyToClipboard
              value={children}
              className="opacity-50 hover:opacity-100 text-white hover:text-cornflower p-3 absolute bottom-0 right-0 md:mb-3 md:mr-3"
            />
          )}

          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={i} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
}
